import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";

const URL = "https://www.travelbackland.com/onsite-experiences";
const TITLE = "Onsite Experiences & Amenities — Things to Do at Backland";
const DESC =
  "On-property experiences at Backland: stargazing, fire pits, trails, kayaking, beach, disc golf, fishing and more. Amenities that make every hour of your stay something to remember.";
const OG_IMAGE =
  "https://www.travelbackland.com/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/night-hot-tub.png";

export const Route = createFileRoute("/onsite-experiences")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "TouristAttraction",
          name: "Onsite Experiences at Backland",
          url: URL,
          description: DESC,
        }),
      },
    ],
  }),
  component: OnsiteRoute,
});

function OnsiteRoute() {
  return <StoryExperience initialCategorySlug="onsite" />;
}
